import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  Typography,
  Space,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { getAllMaster } from "../../redux/rtk/features/masters/masterSlice";
import { addSalaryComponents, loadAllSalaryComponents } from "../../redux/rtk/features/salaryComponent/salaryComponentSlice";
import PageTitle from "../page-header/PageHeader";

function CustomTable({ list, loading, onEdit }) {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Name",
      dataIndex: "ComponentName",
      key: "ComponentName",
    },
    {
      id: 3,
      title: "Code",
      dataIndex: "ComponentCode",
      key: "ComponentCode",
    },
    {
      id: 4,
      title: "Type",
      dataIndex: "ComponentTypeName",
      key: "ComponentTypeName",
    },
    {
      id: 5,
      title: "Amount Type",
      dataIndex: "ComponentAmountTypeName",
      key: "ComponentAmountTypeName",
    },
    {
      id: 6,
      title: "Amount",
      dataIndex: "ComponentAmount",
      key: "ComponentAmount",
    },
    {
      id: 7,
      title: "Pro Rata",
      dataIndex: "IsProRata",
      key: "IsProRata",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      id: 8,
      title: "Taxable",
      dataIndex: "IsTaxable",
      key: "IsTaxable",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      id: 9,
      title: "Action",
      dataIndex: "ComponentId",
      key: "action",
      render: (id, record) => (
        <Space>
          <ViewBtn path={`/admin/salary-components/${id}/`} />
          {/* <UserPrivateComponent permission={"update-salaryComponent"}> */}
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
            />
          {/* // </UserPrivateComponent> */}
        </Space>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.ComponentId, serial: index + 1 }));

  return (
    <>
      <div className="flex my-2 justify-between">
        <div className="w-50">
          <h4 className="text-xl mb-2">Salary Components List</h4>
        </div>
        {list && (
          <div style={{ width: 300, marginLeft: "10px" }}>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="salary-components"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      {list && (
        <div
          className="salary-component-table-actions"
          style={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      {loading ? (
        <div className="text-center py-8">
          <div className="ant-spin ant-spin-lg ant-spin-spinning">
            <span className="ant-spin-dot ant-spin-dot-spin">
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
            </span>
          </div>
          <p className="mt-4 text-gray-600">Loading components...</p>
        </div>
      ) : !list || list.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-600">No components found.</p>
        </div>
      ) : (
        <Table
          scroll={{ x: true, y: "100%" }}
          pagination={{
            defaultPageSize: 20,
          }}
          columns={columnsToShow}
          dataSource={list ? addKeys(list) : []}
          className="salary-component-table"
        />
      )}
    </>
  );
}

const AddSalaryComponent = ({ drawer }) => {
  const { list, loading } = useSelector((state) => state.salaryComponents);
  const masterData = useSelector((state) => state.masters.masters);
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentComponentId, setCurrentComponentId] = useState(0);
  const [componentTypes, setComponentTypes] = useState([]);
  const [amountTypes, setAmountTypes] = useState([]);
  const dispatch = useDispatch();
// console.log("masterDatamasterData", masterData);

  useEffect(() => {
    dispatch(loadAllSalaryComponents());
    dispatch(getAllMaster());
  }, [dispatch]);

  useEffect(() => {
    if (masterData && masterData.SalaryComponentTypeMaster && masterData.SalaryComponentAmountTypeMaster) {
      setComponentTypes(masterData.SalaryComponentTypeMaster);
      setAmountTypes(masterData.SalaryComponentAmountTypeMaster);
    }
  }, [masterData]);

  const handleEdit = (record) => {
    setIsEditMode(true);
    setCurrentComponentId(record.ComponentId);
    form.setFieldsValue({
      ComponentName: record.ComponentName,
      ComponentCode: record.ComponentCode,
      ComponentTypeId: record.ComponentTypeId,
      ComponentAmountTypeId: record.ComponentAmountTypeId,
      ComponentAmount: record.ComponentAmount,
      IsProRata: record.IsProRata,
      IsTaxable: record.IsTaxable,
    });
  };

  const resetForm = () => {
    form.resetFields();
    setIsEditMode(false);
    setCurrentComponentId(0);
  };

  const onFinish = async (values) => {
    setLoader(true);
    const payload = {
      ComponentId: currentComponentId,
      ComponentTypeId: values.ComponentTypeId,
      ComponentName: values.ComponentName,
      ComponentCode: values.ComponentCode,
      ComponentAmountTypeId: values.ComponentAmountTypeId,
      ComponentAmount: values.ComponentAmount || 0,
      IsProRata: values.IsProRata || false,
      IsTaxable: values.IsTaxable || false,
      DataStatus: 1,
      CreatedBy: 1,
      ModifiedBy: 1,
    };

    const resp = await dispatch(addSalaryComponents(payload));

    if (resp.payload.message === "success") {
      setLoader(false);
      resetForm();
      dispatch(loadAllSalaryComponents());
      toast.success(isEditMode ? "Salary component updated successfully" : "Salary component added successfully");
    } else {
      setLoader(false);
      toast.error(isEditMode ? "Failed to update salary component" : "Failed to add salary component");
    }
  };

  const onFinishFailed = () => {
    toast.warning("Please fill all required fields correctly");
    setLoader(false);
  };

  const { Title } = Typography;

  return (
    <div className="add-salary-component-page-wrapper">
      <Row gutter={[16, 16]} className="add-salary-component-row">
        <Col xs={24} sm={24} md={8} lg={8} xl={8} className="column-design border rounded card-custom add-salary-component-form-col">
          <Title level={4} className="m-2 mt-2 mb-5 text-center">
            {isEditMode ? "Edit Salary Component" : "Add Salary Component"}
          </Title>
          <Form
                form={form}
                name="salaryComponentForm"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  label={<span className="required-label">Name:</span>}
                  name="ComponentName"
                  rules={[
                    {
                      required: true,
                      message: "Please input component name!",
                    },
                  ]}
                >
                  <Input placeholder="e.g., Basic Salary" />
                </Form.Item>

                <Form.Item
                  label={<span className="required-label">Code:</span>}
                  name="ComponentCode"
                  rules={[
                    {
                      required: true,
                      message: "Please input component code!",
                    },
                  ]}
                >
                  <Input placeholder="e.g., BASIC" />
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Component Type
                      <Tooltip title="Select component type">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                  name="ComponentTypeId"
                  rules={[
                    {
                      required: true,
                      message: "Please select component type!",
                    },
                  ]}
                >
                  <Select
                    loading={!componentTypes}
                    showSearch
                    placeholder="Select Component Type"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  >
                    {componentTypes &&
                      componentTypes.map((type) => (
                        <Select.Option
                          key={type.ComponentTypeId}
                          value={type.ComponentTypeId}
                        >
                          {type.ComponentTypeName}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Amount Type
                      <Tooltip title="Select amount type">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                  name="ComponentAmountTypeId"
                  rules={[
                    {
                      required: true,
                      message: "Please select amount type!",
                    },
                  ]}
                >
                  <Select
                    loading={!amountTypes}
                    showSearch
                    placeholder="Select Amount Type"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  >
                    {amountTypes &&
                      amountTypes.map((type) => (
                        <Select.Option
                          key={type.ComponentAmountTypeId}
                          value={type.ComponentAmountTypeId}
                        >
                          {type.ComponentAmountTypeName}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label={<span>Amount:</span>}
                  name="ComponentAmount"
                  rules={[
                    {
                      type: "number",
                      min: 0,
                      message: "Amount must be a non-negative number!",
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="e.g., 5000"
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  label={<span>Pro Rata:</span>}
                  name="IsProRata"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>

                <Form.Item
                  label={<span>Taxable:</span>}
                  name="IsTaxable"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>

                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      block
                      loading={loader}
                    >
                      {isEditMode ? "Update Salary Component" : "Add Salary Component"}
                    </Button>
                    {isEditMode && (
                      <Button size="large" onClick={resetForm}>
                        Cancel
                      </Button>
                    )}
                  </Space>
                </Form.Item>
              </Form>
        </Col>

        <Col xs={24} sm={24} md={16} lg={16} xl={16} className="add-salary-component-table-col">
          <div className="ant-card p-4 rounded salary-component-table-container">
            <CustomTable list={list} loading={loading} onEdit={handleEdit} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AddSalaryComponent;